import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { Box, Typography } from '@mui/material';
import React, { ReactElement } from 'react';

const TEXT_COLOR = '#383838';
const BORDER_COLOR = '#D1D5DC';

export function LeadershipPagination ({
  page,
  totalPages,
  onPrev,
  onNext,
}: {
  page: number;
  totalPages: number;
  onPrev: () => void;
  onNext: () => void;
}): ReactElement {
  const atFirst = page <= 1;
  const atLast = page >= totalPages;

  const btnSx = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '8px',
    border: `1px solid ${BORDER_COLOR}`,
    borderRadius: '8px',
    backgroundColor: '#FFFFFF',
    px: '8px',
    py: '10px',
    fontFamily: '\'Poppins\', sans-serif',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '21px',
    color: TEXT_COLOR,
    cursor: 'pointer' as const,
    '&:hover': { backgroundColor: '#F5F5F5' },
  };

  return (
    <Box
      display="flex"
      justifyContent="flex-end"
      alignItems="center"
      sx={{ width: '100%', maxWidth: 1400 }}
    >
      <Box display="flex" alignItems="center" justifyContent="space-between" width={320}>
        <Box
          component="button"
          type="button"
          onClick={atFirst ? undefined : onPrev}
          disabled={atFirst}
          sx={{
            ...btnSx,
            opacity: atFirst ? 0.5 : 1,
            cursor: atFirst ? 'default' : 'pointer',
            '&:hover': { backgroundColor: atFirst ? '#FFFFFF' : '#F5F5F5' },
          }}
        >
          <ChevronLeftIcon sx={{ fontSize: 16 }} />
          Previous
        </Box>

        <Box
          display="flex"
          gap="8px"
          alignItems="center"
          sx={{
            fontFamily: '\'Poppins\', sans-serif',
            fontSize: '14px',
            fontWeight: 400,
            lineHeight: '21px',
            color: TEXT_COLOR,
          }}
        >
          <Typography component="span" sx={{ fontSize: 'inherit', fontWeight: 'inherit', color: 'inherit' }}>Page</Typography>
          <Typography component="span" sx={{ fontSize: 'inherit', fontWeight: 'inherit', color: 'inherit' }}>{page}</Typography>
          <Typography component="span" sx={{ fontSize: 'inherit', fontWeight: 'inherit', color: 'inherit' }}>of</Typography>
          <Typography component="span" sx={{ fontSize: 'inherit', fontWeight: 'inherit', color: 'inherit' }}>{Math.max(1, totalPages)}</Typography>
        </Box>

        <Box
          component="button"
          type="button"
          onClick={atLast ? undefined : onNext}
          disabled={atLast}
          sx={{
            ...btnSx,
            width: 99,
            justifyContent: 'center',
            opacity: atLast ? 0.5 : 1,
            cursor: atLast ? 'default' : 'pointer',
            '&:hover': { backgroundColor: atLast ? '#FFFFFF' : '#F5F5F5' },
          }}
        >
          Next
          <ChevronRightIcon sx={{ fontSize: 16 }} />
        </Box>
      </Box>
    </Box>
  );
}
